export default class MultiMessageError extends Error {
  constructor (messages) {
    super(messages.join('\n\n'))
    this.messages = messages.slice()
  }
}
